/* eslint max-len: ["error", { "code": 130, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import windowSize from 'react-window-size';
import {Utils} from './Utils';
import {history} from '../store';
import {Link} from 'react-router-dom';

import '../css/TitleAppBar.css';
Utils.init('TitleAppBar');

class TitleAppBar extends React.Component {
    static propTypes = {
        locale: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        windowWidth: PropTypes.number.isRequired,
    };

    handleChange = (value) => {
        history.push(value);
    };

    render() {
        return (
            <div className="titleappbar-div">
                <Link to="/" className="title-menu-link">
                    <img src='static/images/GEK_Logo.png' style={{height: 40}} alt="Logo"/>
                    <h1 className="titleappbar-h1 h1-title-font">{this.props.locale.title}</h1>
                </Link>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.locale.locale,
    location: state.router.location,
});

export default windowSize(connect(
    mapStateToProps
)(TitleAppBar));



// WEBPACK FOOTER //
// ./src/components/TitleAppBar.js